export default "/assets/website/images/newsletter.jpg?3467bb7790a519792c44c899902b95aa";